import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesStaffMain } from './modules/ui/Main';

const StaffPage = (
  <SuspensePage>
    <PagesStaffMain />
  </SuspensePage>
);

export default StaffPage;
